import React, { useState } from "react";
import {
    Menu as MenuIcon,
    ArrowDropDownOutlined,
} from "@mui/icons-material";
import FlexBetween from "components/FlexBetween";
import { useDispatch } from "react-redux";
import profileImage from "assets/undraw_profile.svg";
import { useNavigate } from "react-router-dom";
import {
    AppBar,
    Button,
    Box,
    Typography,
    IconButton,
    Toolbar,
    Menu,
    MenuItem,
} from "@mui/material";
import { handelLogout } from "state/index";
import { designTokens } from "theme";

const Navbar = ({ user, isSidebarOpen, setIsSidebarOpen }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const isOpen = Boolean(anchorEl);
    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => { dispatch(handelLogout()); setAnchorEl(null); };
    const handleChangePassword = () => { setAnchorEl(null); navigate("/change%20password"); };

    return (
        <AppBar
            sx={{
                position: "sticky",
                top: 0,
                zIndex: 40,
                background: "#ffffff",
                borderBottom: "1px solid #dde2ea",
                boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
            }}
        >
            <Toolbar sx={{ justifyContent: "space-between", minHeight: "52px !important", px: 2 }}>
                <FlexBetween>
                    <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)} sx={{ color: "#5a6a85" }}>
                        <MenuIcon />
                    </IconButton>
                </FlexBetween>

                <FlexBetween gap="0.5rem">
                    <Button
                        onClick={handleClick}
                        sx={{
                            display: "flex", alignItems: "center", textTransform: "none",
                            gap: "0.5rem", borderRadius: "6px", px: 1, py: 0.5,
                            "&:hover": { backgroundColor: "#f4f6f9" },
                        }}
                    >
                        <Box component="img" alt="profile" src={profileImage}
                            height="30px" width="30px" borderRadius="50%"
                            sx={{ objectFit: "cover", border: "2px solid #dde2ea" }}
                        />
                        <Box textAlign="left">
                            <Typography fontWeight="600" fontSize="0.8125rem" sx={{ color: "#1a2138" }}>{user.name}</Typography>
                            <Typography fontSize="0.6875rem" sx={{ color: "#5a6a85" }}>{user.occupation}</Typography>
                        </Box>
                        <ArrowDropDownOutlined sx={{ color: "#8896a8", fontSize: "20px" }} />
                    </Button>
                    <Menu anchorEl={anchorEl} open={isOpen} onClose={handleClose} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
                        <MenuItem onClick={() => { setAnchorEl(null); const token = localStorage.getItem("token"); window.open(`${process.env.REACT_APP_BASE_URL}backup/download?token=${token}`, "_blank"); }} sx={{ fontSize: "0.8125rem" }}>Download Backup</MenuItem>
                        <MenuItem onClick={handleChangePassword} sx={{ fontSize: "0.8125rem" }}>Change Password</MenuItem>
                        <MenuItem onClick={handleClose} sx={{ fontSize: "0.8125rem", color: designTokens.error.main }}>Log Out</MenuItem>
                    </Menu>
                </FlexBetween>
            </Toolbar>
        </AppBar>
    );
};

export default Navbar;
